import { unique } from 'radash';
import { useCallback, useMemo, useState } from 'react';
import { ControlItem } from './types';

export const useMainControls = () => {
  const [controls, setState] = useState<ControlItem[]>([]);

  const setControls = useCallback((items: ControlItem[]) => {
    setState(items);
  }, []);

  const addControls = useCallback((...items: ControlItem[]) => {
    const toAppend = [items].flat();
    setState((prev) => unique([...prev, ...toAppend], (control) => control.key));
  }, []);

  const clearControls = useCallback(() => setState([]), []);

  const removeControl = useCallback(
    (key: string) => setState((prev) => prev.filter((control) => control.key !== key)),
    [],
  );

  return useMemo(
    () => ({ controls, setControls, addControls, clearControls, removeControl }),
    [controls, setControls, addControls, clearControls, removeControl],
  );
};
